module.exports = __webpack_public_path__ + "images/bannerPT-a78b95cbed95d0e5af39d281610ead88.jpg";